"use strict";

exports.__esModule = true;
exports["default"] = {
  handleClick: function handleClick(e) {
    e.stopPropagation();
  }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-json-tree/lib/mixins/squash-click-event.js
// module id = 1933
// module chunks = 0